<style lang="scss" scoped>
.transaction-overlay {
    height: 100vh;
    background-color: var(--white-hover);
}
.transaction-detail {
    background: var(--light);
    box-shadow: -6px 0 12px rgba(0, 0, 0, 0.06);
    max-width: 651px;
    border-radius: 2px;
    @media only screen and (max-width: 1025px) {
        box-shadow: none;
    }
}
.cushion {
    height: 100px;
    margin-top: -68px;
}
</style>

<template>
    <div class="row no-gutters">
        <div class="col">
            <div class="transaction-overlay d-flex flex-column align-items-center justify-content-center">
                <img class="cushion mb-32" src="/images/cushion.png" alt="Start to sleep">
                <div class="transaction-detail text-center d-inline-block p-40">
                    <template v-if="!error">
                        <i-loader v-if="loading" class="i-50 fill-gold mb-24 mt-32 i-50" />
                        <i-info v-if="!loading && (!complete || failed || canceled)" class="i-50 fill-gold mb-24 mt-32 i-50" />
                        <i-check-circle v-if="!loading && paid" class="mb-24 mt-32 i-50" />
                        <h4 class="fw-b text-primary-dark mb-16">{{ $t('pages.transaction.title')}}</h4>
                        <p class="text-dark mb-48">
                            <template v-if="loading">
                                {{ $t('pages.transaction.loading_desc')}}
                            </template>
                            <template v-if="!loading && !complete">
                                {{ $t('pages.transaction.timeout_desc')}}
                            </template>
                            <template v-if="!loading && paid">
                                {{ $t('pages.transaction.completed_desc')}}
                            </template>
                            <template v-if="!loading && failed">
                                {{ $t('pages.transaction.failed_desc')}}
                            </template>
                            <template v-if="!loading && canceled">
                                {{ $t('pages.transaction.canceled_desc')}}
                            </template>
                        </p>
                        <button v-if="loading" class="btn btn-primary-dark mt-8 w-100 p-12 disabled">{{$t('pages.transaction.loading_cta')}}</button>
                        <button v-if="!loading && !complete" @click="() => pollTransaction(currentUser.user.id, transactionId)" class="btn btn-primary-dark mt-8 w-100 p-12">{{$t('pages.transaction.timeout_cta')}}</button>
                        <button v-if="!loading && paid" @click="goToPlatform" class="btn btn-primary-dark mt-8 w-100 p-12">{{$t('pages.transaction.completed_cta')}}</button>
                        <button v-if="!loading && failed" @click="goToPlatform" class="btn btn-primary-dark mt-8 w-100 p-12">{{$t('pages.transaction.failed_cta')}}</button>
                        <button v-if="!loading && canceled" @click="goToPlatform" class="btn btn-primary-dark mt-8 w-100 p-12">{{$t('pages.transaction.canceled_cta')}}</button>
                    </template>
                    <template v-else>
                        <div class="d-flex align-items-center flex-column">
                            <el-error :error="error" class="mb-24 mt-32" />
                            <p class="text-dark mb-48">
                                <i18n path="pages.transaction.error_desc">
                                    <a :href="contactUrl" target="_blank">{{$t('pages.transaction.error_cta')}}</a>
                                </i18n>
                            </p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { ElError } from '@/components/forms'

export default {
    name: 'transaction-detail',

    components: { ElError },
    data() {
        return {
            loading: true,
            complete: false,
            transactionId: null,
            maxRetries: 13,
            shortRetryTime: 1000,
            longRetryTime: 5000,
            maxShortRetries: 3,
            status: null,
            error: null,
            redirectTime: 5000
        }
    },
    mounted() {
        this.transactionId = this.$route.params.id

        this.pollTransaction(this.currentUser.user.id, this.transactionId)
    },
    methods: {
        pollTransaction(userId, transactionId, times = 0) {
            this.loading = true
            const retryTime = times < this.maxShortRetries ? this.shortRetryTime : this.longRetryTime;
            this.$store.dispatch('payments/readTransaction', { user_id: userId, id: transactionId }).then(t => {
                if ((t.payment_status === 'payment_status.paid' && t.schedules_generated) || (t.payment_status === 'payment_status.failed') || t.payment_status === 'payment_status.canceled') {
                    this.complete = true
                    this.loading = false
                    this.status = t.payment_status
                    return;
                }
                if (times >= this.maxRetries) {
                    this.loading = false
                    return
                }
                setTimeout(() => this.pollTransaction(userId, transactionId, ++times), retryTime)
            })
                .catch(e => {
                    this.error = e
                })
        },
        goToPlatform() {
            return this.$router.push({ name: 'sleep-schedule' })
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        contactUrl() {
            return process.env.VUE_APP_WEBSITE_URL + 'nl/contacteer-ons'
        },
        paid() {
            return this.complete && (this.status && this.status === 'payment_status.paid')
        },
        failed() {
            return this.complete && (this.status && this.status === 'payment_status.failed')
        },
        canceled() {
            return this.complete && (this.status && this.status === 'payment_status.canceled')
        },
    },
    watch: {
        paid(value) {
            if (value) {
                setTimeout(() => this.goToPlatform(), this.redirectTime)
            }
        }
    }
}
</script>
